// @ts-strict-ignore
import mapValues from 'lodash/mapValues';

import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {getProjectId, getWorkspaceId} from 'common/report/util';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint(): string {
  return appApiUrl(`data-definitions/tags`, {
    projectId: getProjectId(),
    workspaceId: getWorkspaceId(),
  });
}

function tagContextMap(tags: string[] | null) {
  if (!tags) {
    return null;
  }

  return tags.reduce((acc, tag) => {
    acc[tag] = tag;

    return acc;
  }, {});
}

export const tagsClient: ApiResourceClient<string> = {
  index() {
    const fetches = apiClient.hydratedGet<string[]>(buildEndpoint());
    return mapValues(fetches, (fetch) => fetch.then((tags) => tagContextMap(tags)));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
